import { useState, useEffect } from 'react'
import { CloudinaryFile } from '../types/cloudinary_custom_types';
import { buildUploadHandler, UploadingFileStatus } from '../utils/cloudinary';


type Props = {
  addMedia: (files: CloudinaryFile[]) => void;
}

function useMultiCloudinaryUpload({ addMedia }: Props): ({
  totalProgress: number,
  uploadFiles: (files: File[]) => void,
}) {

  const [uploadingFilesStatus, setUploadingFilesStatus] = useState<Record<string, UploadingFileStatus>>({})

  const updateFileStatus = (
    signature: string,
    { status, progress }: UploadingFileStatus
  ) => setUploadingFilesStatus(prev => (
    { ...prev, [signature]: { status, progress } }
  ))

  const [files, setFiles] = useState<CloudinaryFile[]>([])

  const addFile = (file: CloudinaryFile) => {
    setFiles(prev => [...prev, file]);
  };

  useEffect(() => {
    // Quand il ya qqun && plus personne n'est loading, on a fini
    const statuses = Object.values(uploadingFilesStatus)
      .map(({ status }) => status)
    if (statuses.length > 0 && statuses.every(s => ["errored", "done"].includes(s))) {
      addMedia(files)
      setFiles([])
      setUploadingFilesStatus({})
    }
  }, [uploadingFilesStatus])

  const uploadFiles = buildUploadHandler({ addFile, updateFileStatus });


  const totalProgress = Object
    .values(uploadingFilesStatus)
    .reduce((acc, { progress }) => acc + progress, 0) / Object.keys(uploadingFilesStatus).length


  return { uploadFiles, totalProgress }
}

export default useMultiCloudinaryUpload
